import {makeAutoObservable, observable} from 'mobx'
import React from 'react'
import {Lang} from 'yougile-lang'
import {IconButton} from '@components/common/base/buttons'
import {Icon} from '../icon'

interface Props {
  onClick?: (e: React.MouseEvent) => void
  active?: boolean
}

export const MarkImportantButton = ({onClick, active}: Props) => {
  if (active) {
    return (
      <div className="w-24 h-24 flex items-center justify-center">
        <Icon
          icon="IconCustomAlertCircle"
          size={20}
          className="flex-none bg-action-default rounded-50"
          color="generic-white"
        />
      </div>
    )
  }

  return (
    <IconButton
      icon="IconCustomAlertCircle"
      size="small"
      wrapperSize="big"
      bgStyle="message"
      className="flex-none"
      content={Lang.msg.chat.markUnreadHint}
      onClick={onClick}
    />
  )
}

export class MarkUnreadUpdater {
  state: {modified: number} = {modified: 0}
  constructor() {
    makeAutoObservable(this, {state: observable.shallow}, {autoBind: true})
  }

  update() {
    this.state.modified = Date.now()
  }
}
export const markUnreadUpdater = new MarkUnreadUpdater()
